import { useEffect, useState } from "react";
import { UserPlus } from "lucide-react";
import { inputClass } from "./FormField";
import { searchInvoicePatients } from "../api/claimsApi";

type Option = { key: string; label: string };

type Props = {
  invoiceId: number;
  onPick: (option: Option) => void;
};

/** Ajout d'un patient de la facture : recherche par nom ou matricule (agents et ayants droit du portefeuille). */
export function PatientSearch({ invoiceId, onPick }: Props) {
  const [term, setTerm] = useState("");
  const [results, setResults] = useState<Option[]>([]);

  useEffect(() => {
    if (term.trim().length < 2) {
      setResults([]);
      return;
    }
    const timer = window.setTimeout(() => {
      searchInvoicePatients(invoiceId, term).then(setResults).catch(() => setResults([]));
    }, 250);
    return () => window.clearTimeout(timer);
  }, [invoiceId, term]);

  return (
    <div className="relative">
      <div className="flex items-center gap-2">
        <UserPlus size={16} className="shrink-0 text-primary" />
        <input
          aria-label="Ajouter un patient de la facture"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          placeholder="Ajouter un patient : nom ou matricule (agent ou ayant droit)…"
          className={`${inputClass} h-9 text-sm`}
        />
      </div>
      {results.length > 0 ? (
        <ul className="absolute z-20 mt-1 max-h-72 w-full overflow-y-auto rounded-lg border border-border bg-card shadow-lg">
          {results.map((result) => (
            <li key={result.key}>
              <button
                type="button"
                onClick={() => {
                  onPick(result);
                  setTerm("");
                  setResults([]);
                }}
                className={`w-full px-3 py-1.5 text-left text-sm hover:bg-accent/20 ${result.key.startsWith("f:") ? "pl-8 text-muted" : "text-foreground"}`}
              >
                {result.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
